import auth from '../api/auth';

export const authUser = (username, password) =>
    new Promise(function (resolve, reject) {
        auth.authUser(username, password).then(data => {
            resolve(data);
        });
    });